module.exports = __webpack_public_path__ + "static/media/accounting.2383b2c1.svg";